export class SuperRouteUtil {
  getSuperRoute(params: { contentid?: string } = {}): string {
    if (useDevice().isDesktop) {
      return import.meta.env.VITE_GOOGLEPLAY_BASE_URL;
    }
    let url: string = `${import.meta.env.VITE_SUPERROUTE_BASE_URL}?product=autoclub&page=home&tap_menu=Auto_Guru`;
    if (params.contentid !== undefined) {
      url += `&redirect_by_id=${params.contentid}`;
    }
    return url;
  }
}
